import { IUserInfo } from './IUserInfo';
import { Set } from './Set';

export class SetOfUsers extends Set<IUserInfo> {

  private static usernameSelector = (user: IUserInfo) => user.id;

  constructor() {
    super(SetOfUsers.usernameSelector);
  }

  public static singletonForUser(user: IUserInfo): SetOfUsers {
    return Set.singleton(user, SetOfUsers.usernameSelector);
  }

}
